import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  RiDashboardLine,
  RiLogoutBoxLine,
} from "react-icons/ri";
import { FiKey, FiUsers } from "react-icons/fi";
import { BiUser } from "react-icons/bi";
import { GrTransaction } from "react-icons/gr";
import { FaRegUser } from "react-icons/fa6";
import { SlUserFollow } from "react-icons/sl";
import { MdGTranslate, MdOutlineBallot, MdMenuBook, MdOutlineAnalytics } from "react-icons/md";
import { BiSolidReport } from "react-icons/bi";

import { BsChatDots, BsHouse, BsHouseDoor } from "react-icons/bs";
import { TbDiscount, TbPigMoney, TbReportSearch } from "react-icons/tb";
import "bootstrap/dist/css/bootstrap.min.css";
import Accordion from "react-bootstrap/Accordion";
import { Ucontext } from "../context/Ucontext";
import { useLocation } from "react-router-dom";
import { constants } from "../utils/constants";

const Sidebar = ({ isCollapsed = false }) => {
  const { authState, authDispatch, logout } = useContext(Ucontext);
  const { user: adminUser } = authState;

  //state
  const location = useLocation();
  const isPropertiesActive = ["/rentprop", "/unrentprop"].includes(location.pathname);
  const isTransactionsActive = [
    "/transactions/rentalInfo",
    "/transactions/assigned",
  ].includes(location.pathname);
  const isReportsActive = [
    "/reports",
    "/landlord-metrics",
    "/tenant-metrics",
    "/insurance-protect-metrics",
    "/llm-cost-analysis",
    "/voice-conversations",
    "/tickets",
    "/skor-tickets"
  ].includes(location.pathname);
  const isInsightsActive = [
    "/translation",
    "/forensic-analysis",
    "/experian-report",
    "/voice-conversations",
    "/credits-ledger",
    "/analysis-ledger",
  ].includes(location.pathname);
  const canViewAdminTools =
    adminUser?.role === constants.ADMIN ||
    adminUser?.role === constants.SUPER_ADMIN;

  const logoutAdmin = () => {
    logout();
    authDispatch({ type: "LOGOUT", payload: "logged out" });
  };

  return (
    <div className={`sidebar-panel ${isCollapsed ? "is-collapsed" : ""}`}>
      <div className="sidebarhead">
        <Link className="logobar" to="/" title="Uno admin">
          <img src="/images/logo.svg" alt="Uno admin" />
        </Link>

        {/* <div className="sidebar-user">
          <span className="sidebar-user-avatar">
            {(adminUser?.name || adminUser?.email || "A").charAt(0).toUpperCase()}
          </span>
          <span className="sidebar-user-copy">
            <strong>{adminUser?.name || "Admin"}</strong>
            <small>{adminUser?.role || "Dashboard"}</small>
          </span>
        </div> */}

        <ul>
          <li className="sidebar-section">
            <span>Overview</span>
          </li>
          <li>
            <NavLink
              onClick={() => document.body.classList.remove("main")}
              to="/"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <RiDashboardLine size={20} />
              <span className="sidebar-link-label">Dashboard</span>
            </NavLink>
          </li>

          <li className="sidebar-section">
            <span>Reports</span>
          </li>
          <li>
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header className={isReportsActive ? "active" : ""}>
                  <TbReportSearch size={20} />
                  <span className="sidebar-link-label">Reports</span>
                </Accordion.Header>
                <Accordion.Body>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to={`/reports`}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <BiSolidReport size={18} />
                    <span className="sidebar-link-label">All Reports</span>
                  </NavLink>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to={`/landlord-metrics`}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <MdOutlineAnalytics size={18} />
                    <span className="sidebar-link-label">Landlord Metrics</span>
                  </NavLink>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to={`/tenant-metrics`}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <MdOutlineAnalytics size={18} />
                    <span className="sidebar-link-label">Tenant Metrics</span>
                  </NavLink>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to={`/insurance-protect-metrics`}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <MdOutlineAnalytics size={18} />
                    <span className="sidebar-link-label">Insurance Metrics</span>
                  </NavLink>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to={`/llm-cost-analysis`}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <TbPigMoney size={18} />
                    <span className="sidebar-link-label">
                      LLM Cost Analysis
                    </span>
                  </NavLink>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to={`/voice-conversations`}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <BsChatDots size={18} />
                    <span className="sidebar-link-label">
                      11Labs Conversations
                    </span>
                  </NavLink>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to={`/tickets`}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <MdOutlineBallot size={18} />
                    <span className="sidebar-link-label">Support Tickets</span>
                  </NavLink>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to={`/skor-tickets`}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <MdOutlineBallot size={18} />
                    <span className="sidebar-link-label">Skor Tickets</span>
                  </NavLink>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </li>
          {/* <li>
              <NavLink
                onClick={() => document.body.classList.remove("main")}
                to="/offers"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <TbDiscount size={20} />
                <span className="sidebar-link-label">Offers</span>
              </NavLink>
            </li> */}

          <li className="sidebar-section">
            <span>People</span>
          </li>
          <li>
            <NavLink
              onClick={() => document.body.classList.remove("main")}
              to="/landlord"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <BsHouseDoor size={20} />
              <span className="sidebar-link-label">Landlord / Agent</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              onClick={() => document.body.classList.remove("main")}
              to={`/tenants`}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FiUsers size={20} />
              <span className="sidebar-link-label">Tenants</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              onClick={() => document.body.classList.remove("main")}
              to={`/waitlist`}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <BiUser size={20} />
              <span className="sidebar-link-label">Waitlist</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              onClick={() => document.body.classList.remove("main")}
              to={`/potential/landlords`}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FaRegUser size={20} />
              <span className="sidebar-link-label">Potential Landlords</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              onClick={() => document.body.classList.remove("main")}
              to={`/api-token-management`}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <FiKey size={20} />
              <span className="sidebar-link-label">Api Token Management</span>
            </NavLink>
          </li>

          <li className="sidebar-section">
            <span>Transactions</span>
          </li>
          <li>
            <Accordion defaultActiveKey={"1"}>
              <Accordion.Item eventKey="1">
                <Accordion.Header
                  className={isTransactionsActive ? "active" : ""}
                >
                  <GrTransaction size={20} />
                  <span className="sidebar-link-label">Transactions</span>
                </Accordion.Header>
                <Accordion.Body>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to="/transactions/rentalInfo"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span className="sidebar-child-dot" />
                    <span className="sidebar-link-label">Tenant Rental</span>
                  </NavLink>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to="/transactions/assigned"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span className="sidebar-child-dot" />
                    <span className="sidebar-link-label">
                      Assigned Properties
                    </span>
                  </NavLink>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </li>

          <li className="sidebar-section">
            <span>Properties</span>
          </li>
          <li>
            <Accordion defaultActiveKey={"1"}>
              <Accordion.Item eventKey="1">
                <Accordion.Header
                  className={isPropertiesActive ? "active" : ""}
                >
                  <BsHouse size={20} />
                  <span className="sidebar-link-label">Properties</span>
                </Accordion.Header>
                <Accordion.Body>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to="/rentprop"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span className="sidebar-child-dot" />
                    <span className="sidebar-link-label">
                      Rented Properties
                    </span>
                  </NavLink>
                  <NavLink
                    onClick={() => document.body.classList.remove("main")}
                    to="/unrentprop"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span className="sidebar-child-dot" />
                    <span className="sidebar-link-label">
                      Unrented Properties
                    </span>
                  </NavLink>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </li>

          {adminUser?.role === constants.SUPER_ADMIN && (
            <>
              <li className="sidebar-section">
                <span>Access</span>
              </li>
              <li>
                <NavLink
                  onClick={() => document.body.classList.remove("main")}
                  to={`/add/admin`}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <SlUserFollow size={20} />
                  <span className="sidebar-link-label">Sub Admin</span>
                </NavLink>
              </li>
            </>
          )}

          {canViewAdminTools && (
            <>
              <li className="sidebar-section">
                <span>Insights</span>
              </li>
              <li>
                <Accordion defaultActiveKey={"1"}>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header
                      className={isInsightsActive ? "active" : ""}
                    >
                      <TbReportSearch size={20} />
                      <span className="sidebar-link-label">
                        Reports & Tools
                      </span>
                    </Accordion.Header>
                    <Accordion.Body>
                      <NavLink
                        onClick={() => document.body.classList.remove("main")}
                        to={`/translation`}
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <MdGTranslate size={18} />
                        <span className="sidebar-link-label">Translation</span>
                      </NavLink>
                      <NavLink
                        onClick={() => document.body.classList.remove("main")}
                        to={`/forensic-analysis`}
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <MdOutlineBallot size={18} />
                        <span className="sidebar-link-label">
                          Forensic Analysis
                        </span>
                      </NavLink>
                      <NavLink
                        onClick={() => document.body.classList.remove("main")}
                        to={`/experian-report`}
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <TbReportSearch size={18} />
                        <span className="sidebar-link-label">
                          Experian Report
                        </span>
                      </NavLink>

                      <NavLink
                        onClick={() => document.body.classList.remove("main")}
                        to={`/credits-ledger`}
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <MdMenuBook size={18} />
                        <span className="sidebar-link-label">
                          Credits Ledger
                        </span>
                      </NavLink>
                      <NavLink
                        onClick={() => document.body.classList.remove("main")}
                        to={`/analysis-ledger`}
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <MdMenuBook size={18} />
                        <span className="sidebar-link-label">
                          Analysis Ledger
                        </span>
                      </NavLink>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </li>
            </>
          )}
        </ul>
        <div className="sidebar-logout">
          <NavLink
            onClick={() => {
              logoutAdmin();
            }}
            to="/login"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <RiLogoutBoxLine size={20} />
            <span className="sidebar-link-label">Logout</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
